import React from "react";
import designLogo from "../assets/designLogo01.webp";

const DesignEngineering = () => {
    return (

        <div className="bg-gradient-to-b from-white to-purple-50 py-16 relative">
            {/* Header Section */}
            <div className="text-center mb-12 px-4">
                <h1 className="font-extrabold text-2xl md:text-3xl text-purple-800 mb-2">
                Design and Engineering Services
                </h1>
                <p className="font-medium text-lg md:text-xl text-blue-800">
                    We provide high-standard work for your company solutions
                </p>
            </div>




            {/* <div className="flex flex-col md:flex-row items-center justify-center p-8 bg-gradient-to-r from-gray-100 to-gray-200 min-h-screen"> */}

            <div className="flex flex-col md:flex-row items-center justify-center bg-gradient-to-r ">



                {/* Left Side - Image */}
                <div className="md:w-1/2 w-full flex justify-center">
                    <img
                        src={designLogo}
                        alt="Construction site illustration"
                        className="w-[600px] h-[600px] rounded-lg shadow-2xl transform  "
                    />
                </div>

                {/* Right Side - Content */}
                <div className="md:w-1/2 w-full p-8 pl-8 bg-white rounded-lg shadow-2xl mt-6 md:mt-0 md:ml-6">
                    {/* <h2 className="text-3xl font-extrabold text-gray-800 mb-6 border-b-4 border-blue-500 pb-2">Design and Engineering Services</h2> */}


                    <p className="text-gray-700 leading-relaxed mb-6">
                        At <span className="font-semibold text-purple-700">Powergenic Engineering</span>, we provide cutting-edge, sustainable design and engineering services tailored to your needs. With state-of-the-art technology and industry expertise, we create solutions that optimize efficiency, enhance performance, and ensure quality across all project phases.
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-4 pl-4">
                        <li>
                            <strong className="text-purple-700">Architectural & Structural Design:</strong> Master planning, facade design, space planning, and sustainable interior designs that blend functionality with aesthetics.
                        </li>
                        <li>
                            <strong className="text-purple-700">Mechanical & Process Equipment Design:</strong> PFD preparation, precision equipment sizing, optimized piping design, and advanced 3D modeling.
                        </li>
                        <li>
                            <strong className="text-purple-700">Piping & Static Equipment:</strong> We specialize in the design, fabrication, installation, and maintenance of piping and static equipment used in various industrial applications. Our expertise covers a wide range of equipment, ensuring efficiency, durability, and compliance with industry standards.
                        </li>
                        {/* <li>
                            <strong className="text-purple-700">Clean Room & HVAC Design:</strong> Advanced HVAC, VRV, and ventilation system solutions tailored for controlled environments and industry compliance.
                        </li> */}
                        <li>
                            <strong className="text-purple-700">Effluent Treatment System Design:</strong> Innovative and sustainable solutions for high and low COD/TDS stream treatment, including biological waste treatment systems.
                        </li>
                    </ul>
                    <p className="text-gray-700 mt-6 leading-relaxed">
                        From initial concept to final execution, our expert engineers and designers collaborate closely with clients to transform visionary ideas into practical, high-performing solutions. At <span className="font-semibold text-purple-700">Powergenic Engineering</span>, we ensure your project exceeds the highest industry standards with precision and excellence.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DesignEngineering;
